import API from '../../api/bulkBroadcasts'

const state = {
  records: [],
  meta: { count: 0, currentPage: 1, statusCounts: {} },
  recipients: [],
  recipientsMeta: { count: 0, currentPage: 1, statusCounts: {} },
  uiFlags: { isFetching: false, isFetchingRecipients: false, isUpdating: false },
}

const getters = {
  getAll: s => s.records,
  getMeta: s => s.meta,
  getRecipients: s => s.recipients,
  getRecipientsMeta: s => s.recipientsMeta,
  uiFlags: s => s.uiFlags,
}

// La respuesta trae { payload, meta }; se lee tolerante por si algún consumidor
// viejo recibe el array plano.
const readPayload = data => (Array.isArray(data) ? data : (data?.payload ?? []))
const readMeta = (data, page) => ({
  count: data?.meta?.count ?? 0,
  currentPage: data?.meta?.current_page ?? page,
  statusCounts: data?.meta?.status_counts ?? {},
})

const actions = {
  async fetchAll({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true })
    try {
      const { data } = await API.get(params)
      commit('SET_RECORDS', readPayload(data))
      commit('SET_META', readMeta(data, params.page || 1))
    } catch (error) {
      // La vista muestra el empty state si falla la carga.
      commit('SET_RECORDS', [])
    } finally {
      commit('SET_UI_FLAG', { isFetching: false })
    }
  },

  async fetchRecipients({ commit }, { id, ...params }) {
    commit('SET_UI_FLAG', { isFetchingRecipients: true })
    try {
      const { data } = await API.getRecipients(id, params)
      commit('SET_RECIPIENTS', readPayload(data))
      commit('SET_RECIPIENTS_META', readMeta(data, params.page || 1))
    } catch (error) {
      commit('SET_RECIPIENTS', [])
    } finally {
      commit('SET_UI_FLAG', { isFetchingRecipients: false })
    }
  },

  // Las mutaciones re-lanzan el error para que la vista pueda avisar al usuario.
  async pause({ commit }, id) {
    return runAction(commit, () => API.pause(id))
  },

  async resume({ commit }, id) {
    return runAction(commit, () => API.resume(id))
  },

  async stop({ commit }, id) {
    return runAction(commit, () => API.stop(id))
  },

  async reschedule({ commit }, { id, scheduledAt }) {
    return runAction(commit, () => API.reschedule(id, scheduledAt))
  },
}

const runAction = async (commit, request) => {
  commit('SET_UI_FLAG', { isUpdating: true })
  try {
    const { data } = await request()
    commit('UPDATE_RECORD', data)
    return data
  } finally {
    commit('SET_UI_FLAG', { isUpdating: false })
  }
}

const mutations = {
  SET_RECORDS: (s, records) => { s.records = records },
  SET_META: (s, meta) => { s.meta = meta },
  SET_RECIPIENTS: (s, recipients) => { s.recipients = recipients },
  SET_RECIPIENTS_META: (s, meta) => { s.recipientsMeta = meta },
  UPDATE_RECORD: (s, record) => {
    const idx = s.records.findIndex(x => x.id === record.id)
    if (idx !== -1) s.records.splice(idx, 1, record)
  },
  SET_UI_FLAG: (s, flags) => { s.uiFlags = { ...s.uiFlags, ...flags } },
}

export default { namespaced: true, state, getters, actions, mutations }
